import {
  AiFillFacebook,
  AiFillLinkedin,
  AiFillGithub,
  AiFillTwitterCircle
} from "react-icons/ai";

export const aboutZomato = [
  "Who We Are",
  "Blog",
  "Work With Us",
  "Investor",
  "Relations",
  "Report Fraud",
  "Contact Us"
];

export const zomaverse = [
  "Zomato",
  "Blinkit",
  "Feeding India",
  "Hyperpure",
  "Zomaland"
];

export const forRestaurants = ["Partner With Us", "Apps For You"];

export const forEnterprise = ["Zomao For Enterprises"];

export const learnMore = ["Privacy", "Security", "Terms", "Sitemap"];

export const socialLinks = [
  {
    link: "https://www.linkedin.com/in/krathish-k/",
    icon: <AiFillLinkedin size={27} color="black" />
  },
  {
    link: "https://github.com/Krathish-sk?tab=repositories",
    icon: <AiFillGithub size={27} color="black" />
  },
  {
    link: "https://twitter.com/KrathishK",
    icon: <AiFillTwitterCircle size={27} color="black" />
  },
  {
    link: "https://www.facebook.com/login/",
    icon: <AiFillFacebook size={27} color="black" />
  }
];
